import { render, staticRenderFns } from "./newEntitiy.vue?vue&type=template&id=385eec0a&scoped=true&"
import script from "./newEntitiy.vue?vue&type=script&lang=js&"
export * from "./newEntitiy.vue?vue&type=script&lang=js&"
import style0 from "./newEntitiy.vue?vue&type=style&index=0&id=385eec0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385eec0a",
  null
  
)

export default component.exports